import { Component, OnInit } from '@angular/core';
import { TreeService } from '../../General/Tree/tree.service';
import { GeneralExerciseComponent } from '../../General/g-exercise.component';
import { MultiSetTreeBuilder } from '../../General/Tree/MultiSet/multi-set-tree-builder';
import { ActivatedRoute } from '@angular/router';
import { TopicService } from '../topic.service';
import { MessageService } from '../../shared/message.service';
import { TreeWords } from './tree-words';
import { MultiSetTreeNode } from '../../General/Tree/MultiSet/multi-set-tree-node';
import { analyzeAndValidateNgModules } from '@angular/compiler';
import { MultipleChoiceGraph } from '../../General/Tree/multipleChoice/multiple-choice-graph';
import { Node } from '../../General/graph/lib/node';

@Component({
  selector: 'app-all-words-mult',
  templateUrl: './all-words-mult.component.html',
  styleUrls: ['./all-words-mult.component.css']
})
export class AllWordsMultComponent extends GeneralExerciseComponent {
  private graph: MultiSetTreeBuilder = null;
  private canvas: HTMLCanvasElement = null;
  private multipleChoiceCanvas: HTMLCanvasElement = null;
  private multipleChoiceGraph: MultipleChoiceGraph = null;


  private readonly canvasID: string = 'graph-canvas';
  private readonly multipleChoiceCanvasID: string = 'multiple-choice-canvas';

  private readFromConfig = false;

  private readonly treeService: TreeService;


  constructor(protected activatedRoute: ActivatedRoute, protected topicService: TopicService,
    protected messageService: MessageService, treeService: TreeService) {
    super(activatedRoute, topicService, messageService);
    this.treeService = treeService;
    this.printable = true;
    this.type = 'allWordsMult';
  }

  ngOnInit() {
    super.ngOnInit();
    window.onload = function () { };
    this.canvas = <HTMLCanvasElement>document.getElementById(this.canvasID); //Call this on ngOnInit(), the constructor can't reference it, since it hasn't been initialized
    this.multipleChoiceCanvas = <HTMLCanvasElement>document.getElementById(this.multipleChoiceCanvasID);
    this.canvas.addEventListener('click', this.checkLeftClick, false);
    this.multipleChoiceCanvas.addEventListener('click', this.checkLeftClick, false);
  }
  checkSolution() {
    if (this.multipleChoiceGraph.isSolved()) {
      this.messageService.addAlertWithTimeout(this.get('correct'), 'success', 10000);
      this.solved = true;
      this.state.solved = true;
      this.saveState();

      //TODO store that it is solved in json
      //        this.graph.setFoundMST(true);

    }
    else{
      this.messageService.addAlertWithTimeout("Noch nicht gelöst!", 'danger', 10000);
    }
  }

  setTypeSpecificsFromState() {
    if (this.state.typespecific) {

    }
  }




  checkLeftClick = (e: MouseEvent) => {
    if (this.graph != null && this.multipleChoiceGraph != null
      && this.graph instanceof TreeWords) {
      let selNode: Node = this.graph.getSelectedNode();
      let mcNode: Node = this.multipleChoiceGraph.getSelectedNode();

      if (selNode != null && mcNode != null) {
        if (selNode instanceof MultiSetTreeNode && mcNode instanceof MultiSetTreeNode) {
          if (selNode.getContent() == mcNode.getContent()) {
            selNode.setHidden(false);
            this.multipleChoiceGraph.removeNode(mcNode);
            this.messageService.addAlertWithTimeout(this.get("correctAssign"), 'success', 10000);
          }
          else {
            this.messageService.addAlertWithTimeout(this.get('wrongAssign'), 'danger', 10000);
            this.graph.resetSelectedNode();
            this.multipleChoiceGraph.resetSelectedNode();
          }
        }
        this.graph.resetSelectedNode();
        this.multipleChoiceGraph.resetSelectedNode();

        this.graph.update();
        this.multipleChoiceGraph.update();
      }

    }

    this.graph.update();
    this.multipleChoiceGraph.update();
  }




  computeState() {
    if (this.graph !== null) {

    }
  }

  resetState() {
    super.resetState();
  }

  setTypeSpecificsFromConfiguration() {
    window.onload = function () { };
    this.canvas = <HTMLCanvasElement>document.getElementById(this.canvasID);
    this.multipleChoiceCanvas = <HTMLCanvasElement>document.getElementById(this.multipleChoiceCanvasID);

    /*Call this on ngOnInit(), the constructor can't reference it, since it hasn't been initialized*/
    let alphabet: [any[], number][] = this.treeService.importTree(this.configuration);
    let hasRep: boolean = this.treeService.importHasRepetition(this.configuration);
    this.graph = new TreeWords(alphabet, hasRep, this.canvas);
    this.graph.buildTree();

    let rootContent: any[] = this.treeService.importSubNode(this.configuration);
    if (rootContent.length > 0) {
      if (this.graph instanceof TreeWords) {
        this.graph.setSubNode(rootContent);
      }
    }
    else {
    }
    this.graph.update();

    let hiddencontents: any[][] = this.treeService.importHiddenNodes(this.configuration);
    if (this.graph instanceof TreeWords) {
      this.graph.setHiddenNodes(hiddencontents);

      this.multipleChoiceGraph = new MultipleChoiceGraph(this.multipleChoiceCanvas, this.graph.getHiddenNodesAsNodes());
      this.multipleChoiceGraph.update();
      this.graph.update();

    }
    this.readFromConfig = true;
  }

  /**
   * Import contents of hidden nodes, and set actual nodes which contain the same content to be hidden
   */
  private initHiddenNodes() {

  }

  private sameContent(realContent: any[], content: any[]): boolean {
    let hasSameContent: boolean = true;
    hasSameContent = content.length == realContent.length;

    let i: number = 0;
    for (i = 0; i < content.length; i++) {
      hasSameContent = hasSameContent && (content[i] == realContent[i]);
    }
    return hasSameContent;
  }

  evaluate(): [number, number] {
    if (this.graph instanceof TreeWords) {
      let maxPoints: number = this.graph.getHiddenNodesAsNodes().length;
      let points: number = this.multipleChoiceGraph.getNodes().length;
      return [maxPoints - points, maxPoints];
    }
    return [0,1];
  }



}
